import React, { memo } from 'react';

const ReportsIcon = ({ color = '#335B70', ...props }) => (
    <svg {...props} viewBox="0 0 32 32">
        <path
            fill={color}
            d="M32 11.13c0 1.535-1.248 2.783-2.783 2.783-0.089 0-0.173-0.018-0.259-0.026l-4.169 5.837c0.159 0.35 0.254 0.736 0.254 1.146 0 1.535-1.248 2.783-2.783 2.783s-2.783-1.248-2.783-2.783c0-0.21 0.028-0.413 0.072-0.609l-5.517-5.092c-0.26 0.080-0.53 0.136-0.816 0.136-0.538 0-1.037-0.16-1.463-0.425l-6.2 3.306c-0.053 1.488-1.271 2.684-2.772 2.684-1.535 0-2.783-1.248-2.783-2.783s1.248-2.783 2.783-2.783c0.538 0 1.037 0.16 1.463 0.426l6.2-3.306c0.053-1.488 1.271-2.684 2.772-2.684 1.535 0 2.783 1.248 2.783 2.783 0 0.21-0.028 0.413-0.072 0.609l5.517 5.092c0.26-0.080 0.53-0.136 0.816-0.136 0.089 0 0.173 0.018 0.259 0.026l4.169-5.837c-0.159-0.35-0.254-0.736-0.254-1.146 0-1.535 1.248-2.783 2.783-2.783s2.783 1.248 2.783 2.783z"
        />
    </svg>
);

export default memo(ReportsIcon);
